"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlterMode = void 0;
/**
 * Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages.
 */
var AlterMode;
(function (AlterMode) {
    /**
     * None of the ALTER experiments will be used when resolving localization messages.
     */
    AlterMode["NONE"] = "NONE";
    /**
     * This is the default. Only released ALTER experiments will be used when resolving localization messages.
     */
    AlterMode["RELEASED"] = "RELEASED";
    /**
     * Both released and draft ALTER experiments will be used when resolving localization messages.
     */
    AlterMode["PREVIEW"] = "PREVIEW";
    /**
     * Localization messages will be replaced with their namespace and loc key.
     */
    AlterMode["DEBUG"] = "DEBUG";
})(AlterMode = exports.AlterMode || (exports.AlterMode = {}));
//# sourceMappingURL=alter-mode.js.map